export const IT_PAGE_PATHS = {
  "/oferta": "/offerta",
  "/platnosc": "/pagamento",
  "/rejestracja": "/registrazione",
  "/potwierdzenie": "/conferma",
} as const;
